import Breakpoints from '~/constants/Breakpoints';

export function deviceType() {
  const isMobile =
    typeof window.matchMedia === 'function' &&
    window.matchMedia(
      `only screen and (max-device-width: ${Breakpoints.md.min}px)`
    ).matches;

  const isTablet =
    typeof window.matchMedia === 'function' &&
    window.matchMedia(
      `only screen and (min-device-width: ${Breakpoints.md.min}px) and (max-device-width: ${Breakpoints.xl.min}px)`
    ).matches;

  if (isMobile) {
    return 'Mobile';
  } else if (isTablet) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
}
